export var PurchaseCurrency;
(function (PurchaseCurrency) {
    PurchaseCurrency["EUR"] = "eur";
})(PurchaseCurrency || (PurchaseCurrency = {}));
//# sourceMappingURL=purchase-currency.enum.js.map